import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/system";
import { Link } from "react-router-dom";
import productHuntLogo from "../../../assets/svg/producthunt-official.svg";
import xLogo from "../../../assets/svg/x-social-media-logo-icon.svg";
import hackerNewsLogo from "../../../assets/svg/hacker-news-icon.svg";

const whiteLogos = [
  {
    svg: productHuntLogo,
    url: "https://www.product-hunt.com",
  },
  {
    svg: xLogo,
    url: "https://www.x.com",
  },
  {
    svg: hackerNewsLogo,
    url: "https://www.hackernews.com",
  },
];

const darkLogos = [
  {
    svg: productHuntLogo,
    url: "https://www.product-hunt.com",
  },
  {
    svg: xLogo,
    url: "https://www.x.com",
  },
  {
    svg: hackerNewsLogo,
    url: "https://www.hackernews.com",
  },
];

const logoStyle = {
  width: "100px",
  height: "80px",
  margin: "0 32px",
  opacity: 0.7,
};

export default function LogoCollection() {
  const theme = useTheme();
  const logos = theme.palette.mode === "light" ? darkLogos : whiteLogos;

  return (
    <Box id="logoCollection" sx={{ py: 4 }}>
      <Typography
        component="p"
        variant="subtitle2"
        align="center"
        sx={{ color: "text.secondary" }}
      >
        Featured on
      </Typography>
      <Grid container sx={{ justifyContent: "center", mt: 0.5, opacity: 0.6 }}>
        {logos.map((logo, index) => (
          <Grid item key={index}>
            <Link to={logo.url} target="_blank">
              <img
                src={logo.svg}
                alt={`Fake company number ${index + 1}`}
                style={logoStyle}
              />
            </Link>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
